import styles from "./OverlaySpinner.styles.scss";

const OverlaySpinner = () => {
  return <div className={styles.modalContainer}>
      <div className={styles.loader} />
  </div>;
};

export default OverlaySpinner;



// WEBPACK FOOTER //
// ./components/OverlaySpinner/OverlaySpinner.js